<template>
  <a-config-provider :locale="locale">
    <router-view />
    <!-- <global-setting /> -->
  </a-config-provider>
</template>

<script lang="ts" setup>
    import { computed, onBeforeUnmount } from 'vue';
    import enUS from '@arco-design/web-vue/es/locale/lang/en-us';
    import zhCN from '@arco-design/web-vue/es/locale/lang/zh-cn';
    import zhHK from '@arco-design/web-vue/es/locale/lang/zh-tw';
    // import GlobalSetting from '@/components/global-setting/index.vue';
    import useLocale from '@/hooks/locale';
    import timer from '@/utils/timer';

    const { currentLocale } = useLocale();
    const locale = computed(() => {
        switch (currentLocale.value) {
            case 'zh-CN':
                return zhCN;
            case 'en-US':
                return enUS;
            case 'zh-HK':
                return zhHK;
            default:
                return zhCN;
        }
    });
    onBeforeUnmount(() => timer && clearInterval(timer));
</script>
